module.exports = __webpack_public_path__ + "static/logo-2025-77d21be8da58f4d6bb650c46aa5770fe.png";